import type { JSONContent } from '@tiptap/react';
import { apiGet, apiPost, apiPatch, apiDelete } from './api';

// Paths here must NOT carry an /api prefix: the helpers prepend API_BASE
// ('/api'). Including it produces /api/api/... and a 404 that unit tests
// mocking the helpers cannot see, because they only observe the argument.

export interface Scratchpad {
  id: string;
  title: string;
  content: string | null;
  scope_id: string | null;
  user_id: string | null;
  sort_order: number;
  is_archived: number;
  created_at: string;
  updated_at: string;
}

export interface ScratchpadHit extends Scratchpad { snippet: string }

export interface PromoteResult { entity_type: 'task' | 'note'; entity_id: string; label: string }

export const listScratchpads = () => apiGet<Scratchpad[]>('/scratchpads');
export const getScratchpad = (id: string) => apiGet<Scratchpad>(`/scratchpads/${id}`);
export const createScratchpad = (body: Partial<Scratchpad> = {}) =>
  apiPost<Scratchpad>('/scratchpads', body);
export const updateScratchpad = (id: string, body: Partial<Scratchpad>) =>
  apiPatch<Scratchpad>(`/scratchpads/${id}`, body);
export const deleteScratchpad = (id: string) => apiDelete(`/scratchpads/${id}`);
export const searchScratchpads = (q: string) =>
  apiGet<ScratchpadHit[]>(`/scratchpads/search?q=${encodeURIComponent(q)}`);
export const promote = (
  id: string,
  body: { target: 'task' | 'note'; text: string; scope_id?: string; meeting_instance_id?: string }
) => apiPost<PromoteResult>(`/scratchpads/${id}/promote`, body);

/** API stores TipTap JSON as TEXT; the editor wants a parsed doc. Malformed
    content must not blank the page/drawer, so fall back to null. */
export function parseContent(raw: string | null): JSONContent | null {
  if (!raw) return null;
  try { return JSON.parse(raw) as JSONContent; } catch { return null; }
}
